export const settings = {
  APP_VERSION: "2.1.0",
  GOOGLE_API_KEY: "AIzaSyAbquQkju85Ho0VUlMI_TgWP6hUQlzZ7UI",
  // Partner-admin is a separate app with one origin per environment (partners.kayana.co.uk,
  // partners.dev/test/stg...), so CI supplies it the same way it supplies REACT_APP_API_URL.
  // The live partners portal is the default — the same host Redirection.jsx already uses.
  PARTNER_ADMIN_URL: (
    process.env.REACT_APP_PARTNER_ADMIN_URL || "https://partners.kayana.co.uk"
  ).replace(/\/+$/, ""),
};
